import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

// Attaches a shared X-MDT-Gate header to requests hitting our own droplet
// backends (queries/rag/speech, plus chat's one plain-HTTP route) in dev/tst
// only. Nginx checks this header on dev-*/tst-* subdomains to filter out
// casual bots/scanners hitting these publicly-enumerable hostnames (see
// audit-reports/droplet-hardening-audit-2026-07-20.md, Section J) — it is
// NOT a real security boundary (the value ships in the compiled JS bundle),
// the app's own JWT auth remains the actual access control.
//
// A separate header (not Authorization) is used deliberately: AuthInterceptor
// already sets Authorization: Bearer <jwt> on these same requests, and a
// single request can't carry two different Authorization schemes at once.
//
// chat's Socket.io connection is NOT covered by this interceptor or by the
// nginx gate — browsers cannot attach custom headers to a native WebSocket
// handshake, and guest/anonymous chat is an intentional product feature
// (see my-dream-team-chat/middleware/verifyToken.js socketAuth), so gating
// it here would risk breaking that. Its own per-user rate limiter
// (services/rateLimiter.js) is the relevant protection there instead.
@Injectable()
export class DevGateInterceptor implements HttpInterceptor {
  private ownOrigins = [environment.dbBaseUrl, environment.ragApiURL, environment.speechApiURL, environment.openaiChatApiURL]
    .filter(Boolean)
    .map(base => {
      try { return new URL(base).origin; } catch { return null; }
    })
    .filter((origin): origin is string => !!origin);

  private isOwnBackend(url: string): boolean {
    try {
      return this.ownOrigins.includes(new URL(url, window.location.origin).origin);
    } catch {
      return false;
    }
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!environment.devGateSecret || !this.isOwnBackend(req.url)) {
      return next.handle(req);
    }

    return next.handle(req.clone({ setHeaders: { 'X-MDT-Gate': environment.devGateSecret } }));
  }
}
